import {lazyRegister} from '@/Core/lazyRegister';
import './menu-node.component.css';
import template from './menu-node.component.html';
import {RolesType} from "@/models";

export type MenuNode = {
    menuKey?: string;
    icon?: string;
    link?: string;
    rolesAllowed?: RolesType[];
    rolesExcluded?: RolesType[];
    isSubLevel?: boolean;
    hasSeparator?: boolean;
    disabled?: boolean;
    isExternal?: boolean;
    children?: MenuNode[];
}

class MenuNodeController {
    static $inject = ['$element'];
    public node!: MenuNode; // Input nhận vào từ component cha
    public isSubmenu: boolean = false; // Input nhận biết có phải menu con cấp trong không

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('menu-node');
        this.isSubmenu = !!(this.node.children && this.node.children.length > 0);
    }
}

export const MenuNodeComponent: ng.IComponentOptions = {
    bindings: {
        node: '<'
    },
    template: template,
    controller: MenuNodeController
};

lazyRegister.component('menuNode', MenuNodeComponent);